import { takeLatest, put } from 'redux-saga/effects';
import {
  LOAD_COMMISSION_SETTINGS,
  setCommissionPayoutSettings,
  commissionPayoutSettingsFailed
} from './reducer';
import { getRequest } from '../../utilities/requests';

function* handleLoadCommissionPayoutSettingsSaga() {
  try {
    const url = '/commission_payout_settings';
    const response = yield getRequest(url);
    yield put(setCommissionPayoutSettings(response.data));
  } catch (error) {
    yield put(commissionPayoutSettingsFailed());
  }
}

export function* loadCommissionPayoutSettingsSaga() {
  yield takeLatest(
    LOAD_COMMISSION_SETTINGS,
    handleLoadCommissionPayoutSettingsSaga
  );
}
